var _image;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOpen({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "34px",
    height: "44px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _image || (_image = /*#__PURE__*/React.createElement("image", {
    x: "0px",
    y: "0px",
    width: "34px",
    height: "44px",
    xlinkHref: "data:img/png;base64,iVBORw0KGgoAAAANSUhEUgAAACIAAAAsCAMAAAA3k5qAAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAANlBMVEX/AAD/////AAD/AAD/AAD/AAD/AAD/AAD/AAD/AAD/AAD/AAD/AAD/AAD/AAD/AAD/AAD///+NWgsDAAAAEHRSTlMAAC6HxfF6tbdciUzT1T54ml8ZGQAAAAFiS0dEAf8CLd4AAAAHdElNRQfoAhQSMDh7nlmUAAAAvElEQVQ4y+WT7Q6DIAxF3RVQRGvf/2nHx8TBpJpsWZbs/CscewnYriuBp2sD9Eoza9W3NBjOmEMHAz8xHDgYuWBEI0VZwKrjLMRlG5dhY1Er025szlQpqohHKFWVo0OTvQ5tdJmEKhyvh6mWbhufVcLrRiWTlfQV3MxNZhckxyLON1lkZcHjcQT+QDFERlbI3zdIUtJfDyMolJ7evadcCLpwXOaVaP3K7f68cj4kF0bND6zQZ3HIY9/Cb98BDug9kZSZAEAAAAAASUVORK5CYII="
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpen);
export default __webpack_public_path__ + "static/media/open.1c91846a909055624abee7627056910a.svg";
export { ForwardRef as ReactComponent };